module.exports = __webpack_public_path__ + "media/images/flags/64/Croatia-695a3d581d4f4e50c4d27b555b2824af.png";